<template>
  <LayoutResolver>
    <router-view />
  </LayoutResolver>
</template>

<script>
import LayoutResolver from './layouts/LayoutResolver.js'

export default {
  components: {
    LayoutResolver
  }
}
</script>

<style lang="scss">
@use './assets/styles/layout.scss' as *;

.p-toast.p-toast-top-right {
  z-index: 1000;
  top: 7rem;
}
</style>
